import Vue from 'vue'
let bus = new Vue();
let showEvent = '@showUserCard';
let hideEvent = '@hideUserCard';
export default {
  /**
   * 监听显示
   * @type {Function}
   */
  onShow: (function () {
    return function (handler) {
      bus.$on(showEvent, handler)
    }
  })(),
  /**
   * 监听隐藏
   * @type {Function}
   */
  onHide: (function () {
    return function (handler) {
      bus.$on(hideEvent, handler)
    }
  })(),
  /**
   * 显示卡片
   * @param id 卡片用户id
   * @param domRect 显示参照物domRect
   */
  show: function(id, domRect) {
    bus.$emit(showEvent, id, domRect)
  },
  /**
   * 隐藏卡片
   */
  hide: function() {
    bus.$emit(hideEvent)
  }
};



// WEBPACK FOOTER //
// ./src/js/bus/userCardBus.js